module.exports = __webpack_public_path__ + "static/img/003.5c63bdb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt2/003.png
// module id = BzEj
// module chunks = 1